import { Close as CloseIcon } from "@mui/icons-material";
import { Trans, useTranslation } from "react-i18next";
import "./css/connectedModal.scss";
import { BRAND_NAME } from "@constants";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";

interface IParams {
    isModalOpen: boolean;
    setModalOpen(isModalOpen: boolean): void;
}

export const ConnectedModal = (props: IParams) => {
    const { isModalOpen, setModalOpen } = props;
    const closeModal = () => setModalOpen(!isModalOpen);
    const { t } = useTranslation("summary");

    return (
        <Dialog fullWidth maxWidth="md" open={isModalOpen} onClose={closeModal}>
            <Grid className="dialog-close" container justifyContent="flex-end">
                <Grid className="dialog-close__icon" item>
                    <IconButton aria-label="close" size="large" onClick={closeModal}>
                        <CloseIcon color="disabled" />
                    </IconButton>
                </Grid>
            </Grid>
            <DialogTitle>
                <Grid container justifyContent="center">
                    <Grid item sm={12} xs={6}>
                        <Typography align="center" color="secondary" variant="h3">
                            {t("updateInformation")}
                        </Typography>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Typography align="center" variant="normal">
                    <Trans>{t("updateInformationModal", { brand: BRAND_NAME })}</Trans>
                </Typography>
            </DialogContent>
            <DialogActions>
                <Box display="flex" justifyContent="center">
                    <LabeledButton color="secondary" labelText={t("understand")} onClick={closeModal}>
                        {t("understand")}
                    </LabeledButton>
                </Box>
            </DialogActions>
        </Dialog>
    );
};
